export const I18_EN = {
  LANGUAGE: 'EN',
  LNK_HEADER_ABOUT: 'Me',
  LNK_HEADER_SKILLS: 'Skills',
  LNK_HEADER_EXPERIENCE: 'Experience',
  LNK_HEADER_EDUCATION: 'Education',
  LNK_HEADER_PROJECTS: 'Projects',
  LNK_HEADER_CONTACT: 'Contact',
  LNK_HEADER_BLOG: 'Blog',

  TIT_PAGE_TITLE: 'Resume',
  TIT_ABOUT: 'About me',
  TIT_PROF_SKILLS: 'Technical Skills',
  TIT_SOFT_SKILLS: 'Soft Skills',
  TIT_EXPERIENCE: 'Work experience',
  TIT_EDUCATION: 'Education',
  TIT_PORTFOLIO: 'Portfolio',
  TIT_CONTACT: 'Contact me',
  TIT_REFERENCES: 'References',
  TIT_TECK_STACK: 'Technical Profile',
  TIT_FOOTER: 'Quote',

  LBL_ALL: 'All',
  LBL_SEND_A_MESSAGE: 'Send me a message',
  LBL_NAME: 'Name',
  LBL_SUBJECT: 'Subject',
  LBL_EMAIL: 'E-mail',
  LBL_YOUR_MESSAGE: 'Your Message',
  LBL_ADDRESS: 'Address',
  LBL_PHONE: 'Phone',
  LBL_CV: 'Print CV',
  LBL_LANGUAGES: 'Languages',

  BTN_LOAD_MORE: 'Load More',
  BTN_SEND: 'Send',
  BTN_BLOG_READ_MORE: 'Read more',
  BTN_BLOG_BACK_TOBLOG: 'Back to blog',


  FILE_NAME: 'Resume Luis Arias EN'
};
